// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3awrf","addWidgetButton":"Header_addWidgetButton__F0mX8","dashboardTabs":"Header_dashboardTabs__3MHz5","active":"Header_active__h6Yc5"};